import React  from 'react';
import PropTypes from 'prop-types';
import Select from "react-select";

const AccountSelect = ({ loading, ...props }) => {
  return (
    <div style={{ width: "300px" }}>
      <Select
        getOptionLabel ={(option) => option.text }
        getOptionValue ={(option) => option.id }
        isLoading={loading}
        isDisabled={loading}
        {...props}
      />
    </div>
  );
};

AccountSelect.propTypes = {
  loading: PropTypes.bool.isRequired
};

export default AccountSelect;
